export default {
  placeholder: "Please enter...",
  "placeholder.search": "Search...",
  "smart-search.placeholder": "What do you want to do?",
  "enter-password.placeholder": "Enter password...",
  "reason-for-cancellation.placeholder": "Enter reason for cancellation...",
  "signup.date-of-birth.placeholder": "Select date",
  "signup.phone.pre-dial.placeholder": "+49",
  "signup.phone.number.placeholder": "12345678",
  "placeholder.select": "Please select...",
  "placeholder.start-date": "Start date",
  "placeholder.end-date": "End date",
};
